module.exports = __webpack_public_path__ + "media/images/checkbox-on-5577b8e7818c38deca1b8bd04796c443.svg";